import { Controller } from "stimulus"
import i18n from "../../packs/i18n"
import i18next from "i18next";
export default class extends Controller {
  static targets = ["testSelector", "testPrice","fullPrice", "discount", "percent", "startDate", "endDate", "amountCurrency", "amountPercent"]
  
  connect(){
    $('.selectpicker').selectpicker();
    $(this.endDateTarget).datepicker()
    $(this.startDateTarget).datepicker()
    this.togglePercent()
    i18n.then(()=>{
      this.initValidtion()
    })
  }

  initValidtion(){
     let testPrice = this.testPriceTarget
     let testSelectorId = this.testSelectorTarget.id;
     let discountId = this.discountTarget.id;

     $(this.element).validate({
      ignore: [],
      errorPlacement: function(error, element) {
        switch (element.attr("id")) {
          case testSelectorId:
            element.parent().parent().append(error);
            break;
          case discountId:
            element.parent().parent().append(error);
            break;
          default:
            element.parent().append(error);
            break;
        }
      }
    });

    $(this.testSelectorTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });
    });

    $(this.startDateTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });
    });

    $(this.endDateTarget).each(function () {
      $(this).rules('add', {
        required: true,
        messages: {
          required: i18next.t('required_field')
        }
      });
    });

    this.percentDiscountValidation(this.percentTarget.checked)
  }

  percentDiscountValidation(apply=true){
    let testPrice = this.testPriceTarget

    if(apply){
      $(this.discountTarget).rules('add', {
        max: 100,
        messages:{
          max: i18next.t('max_number_with_sign', { sign: '%', number: "{0}" })
        }
      });
    }else{
      $(this.discountTarget).rules('add', {
        max: function(){
          return +parseFloat(testPrice.value).toFixed(2)
        },
        messages:{
          max: i18next.t('max_number_with_sign', { sign: '$', number: "{0}" })
        }
      });
    }
  }

  usePercent(e){
    if(e.target.checked && this.fullPriceTarget.checked){
      this.discountTarget.value = 100
    }else if(!e.target.checked && this.fullPriceTarget.checked) {
      this.discountTarget.value = +parseFloat(this.testPriceTarget.value).toFixed(2)
    }else{
      this.discountTarget.value = null
    }
    this.togglePercent()
    this.percentDiscountValidation(e.target.checked)
  }

  togglePercent(){
    if(this.percentTarget.checked){
      this.amountPercentTarget.classList.remove('d-none')
      this.amountCurrencyTarget.classList.add('d-none')
    }else{
      this.amountPercentTarget.classList.add('d-none')
      this.amountCurrencyTarget.classList.remove('d-none')
    }
  }

  refreshFullPriceValidation(){
    let validator= $(this.element).validate()
    
    if(!validator) return

    validator.element(`#${this.discountTarget.id}`);
  }


  fullPrice(e){
    if(e.target.checked && this.percentTarget.checked){
      this.discountTarget.value = 100
      this.refreshFullPriceValidation()
    }
  }
}
